import {
  type SearchEndpointArgs,
  type SearchResult,
  type SessionsAsset,
  useInfiniteScroll,
  useLazyGetSearchResultsQuery,
} from '@carboncopyco/data';
import { useEffect, useMemo, useState } from 'react';
import { SearchDropdown } from '../../../SearchDropdown';
import { useDashboardProps } from '../../DashboardContext';
import { useFilterLogic } from './useFilterLogic';

type ToursFilterProps = {
  tours: Record<SessionsAsset['assetType'], SessionsAsset['name']>;
  setTours: (
    tours: Record<SessionsAsset['assetId'], SessionsAsset['name']>
  ) => void;
};

export const ToursFilter = ({ tours, setTours }: ToursFilterProps) => {
  const { organizationId } = useDashboardProps();
  const [query, setQuery] = useState('');

  const fetchArgs: SearchEndpointArgs = useMemo(
    () => ({
      organizationId,
      entities: ['tour'],
      query,
      includeArchivedWorkspaces: true,
      deletedEntities: 'include_all',
      allOrgWorkspaces: true,
    }),
    [query, organizationId]
  );

  const {
    items: data,
    isLoading,
    isLoadingBatch,
    fetchFirstBatch,
    fetchNextBatch,
    isEmpty,
  } = useInfiniteScroll<SearchResult>(useLazyGetSearchResultsQuery);

  useEffect(() => {
    fetchFirstBatch(fetchArgs);
  }, [fetchFirstBatch, fetchArgs]);

  const [items, onChange] = useFilterLogic({
    data,
    selectedItems: tours,
    id: 'id',
    label: 'tourName',
    setter: setTours,
  });

  return (
    <SearchDropdown
      placeholder="Tour name"
      capsuleWidth={208}
      contentWidth={208}
      searchableItems={items}
      selectedItems={tours}
      onChange={onChange}
      onClear={() => {
        setTours({});
        setQuery('');
      }}
      query={query}
      setQuery={setQuery}
      onInputChange={() => fetchFirstBatch(fetchArgs)}
      fetchNextBatch={() => fetchNextBatch(fetchArgs)}
      isLoading={isLoading}
      isLoadingBatch={isLoadingBatch}
      disabled={isEmpty}
    />
  );
};
